"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var tool_icons_1 = require("./tool-icons");
var base_1 = require("./base");
var MoreForToolbar = /** @class */ (function (_super) {
    __extends(MoreForToolbar, _super);
    function MoreForToolbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.closeCallBack = function () {
            return _this.props.editor.configurator.emit(_this.props.groupKey + "-close");
        };
        _this.renderIcon = function () {
            var _a = _this.props, icon = _a.icon, editor = _a.editor, _b = _a.toolbarType, toolbarType = _b === void 0 ? 'static' : _b;
            var showIcon = icon;
            if (typeof icon === 'function') {
                showIcon = icon(editor, {}, { toolbarType: toolbarType });
            }
            return showIcon || tool_icons_1.Icons.more;
        };
        _this.renderMenu = function () { return _this.props.renderMenu(); };
        return _this;
    }
    Object.defineProperty(MoreForToolbar.prototype, "isActive", {
        get: function () {
            return Boolean(this.menuRef.current && this.menuRef.current.querySelector('.active'));
        },
        enumerable: true,
        configurable: true
    });
    return MoreForToolbar;
}(base_1.SelectBase));
exports.MoreForToolbar = MoreForToolbar;
//# sourceMappingURL=more.js.map